import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubscriptionEntityExtended } from 'mj_generatedentities';
import { SubscriptionPlanService, SubscriptionPreviewOptions, SubscriptionUpdatePreview } from 'src/app/core/services/subscription-plan.service';

@Component({
  selector: 'app-subscription-update-preview',
  templateUrl: './subscription-update-preview.component.html',
  styleUrl: './subscription-update-preview.component.css'
})
export class SubscriptionUpdatePreviewComponent implements OnInit {
  @Input() subscription: SubscriptionEntityExtended | null = null;
  @Input() options: SubscriptionPreviewOptions | null = null;
  
  @Output() previewLoaded = new EventEmitter<boolean>();

  previewData: SubscriptionUpdatePreview | null = null;
  previewLoadingMessage: string = 'Loading preview...';
  isLoadingPreview = true;

  constructor(private subscriptionService: SubscriptionPlanService) { 
  }

  async ngOnInit(): Promise<void> {
    if (this.subscription && this.options) {
      await this.LoadSubscriptionUpdatePreview(this.subscription, this.options);
    }
  }

  private async LoadSubscriptionUpdatePreview(subscription: SubscriptionEntityExtended, options: SubscriptionPreviewOptions): Promise<void> {
    this.isLoadingPreview = true;
    this.previewLoaded.emit(false); // Emit event to indicate loading has started
    this.previewData = null; // Reset preview data before loading new data

    try {
      this.previewData = await this.subscriptionService.GetSubscriptionUpdatePreview(subscription, options);
    } catch (error) {
      console.error('Error loading subscription update preview:', error);
      this.previewLoadingMessage = 'Error loading preview. Please try again.';
    } finally {
      this.previewLoaded.emit(true); // Emit event to indicate loading has finished
      this.isLoadingPreview = false;
    }
  }
}
